const CALCULATION = 'calculation';
const SET_RESULT = 'set_result';

export const calculation = (
  tweetNumber,
  tweetImpression,
  profileAccess,
  newFollower,
  nowFollower,
) => {
  return {
    type: CALCULATION,
    payload: {
      tweetNumber,
      tweetImpression,
      profileAccess,
      newFollower,
      nowFollower,
    },
  }
};

export const setResult = (
  resultImpression,
  resultProfile,
  resultNewFollower,
  resultTweet,
  isOver1000Follower,
) => {
  console.log('test')
  return {
    type: SET_RESULT,
    payload: {
      resultImpression,
      resultProfile,
      resultNewFollower,
      resultTweet,
      isOver1000Follower,
    }
  }
}
export {
  CALCULATION,
  SET_RESULT,
} 


// WEBPACK FOOTER //
// ./src/actions/AppActions.js